import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTravel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#8589f8",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2561 5.67258H3.77953L3.09682 4.32589L1.67566 4.27625C1.18986 4.2817 0.865101 4.77855 1.05503 5.22576L2.33971 8.12394C2.5509 8.62275 3.03924 8.94751 3.5809 8.94935H6.11294L4.54902 12.1393C4.31922 12.5956 4.65883 13.1322 5.16965 13.1198H6.47293C6.67466 13.1173 6.86516 13.0266 6.99421 12.8716L10.1965 8.93075H13.2995C14.2205 8.97671 14.9941 8.24556 15 7.32341C14.994 6.37726 14.2011 5.62669 13.2561 5.67258Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.302 5.67891L8.44018 3.15304C8.31196 2.98037 8.10921 2.879 7.89408 2.87995H6.59702C6.08602 2.87291 5.74869 3.40917 5.97639 3.86673L6.8701 5.67269",
			fill: "currentColor",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.302 5.67891L8.44018 3.15304C8.31196 2.98037 8.10921 2.879 7.89408 2.87995H6.59702C6.08602 2.87291 5.74869 3.40917 5.97639 3.86673L6.8701 5.67269",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTravel;
